module.exports = __webpack_public_path__ + "img/4.48d2d54c.jpg";